import { useState, useEffect, useRef } from "react";
import BaseButton from "../../../../baseComponents/baseButton";
import BaseInput from "../../../../baseComponents/baseInput";
import { useSelector, useDispatch } from "react-redux";
import { asyncActions as loginAsyncActions } from "../../../../store/slices/loginSlice.js";
import { asyncActions as successAsyncActions } from "../../../../store/slices/successSlice.js";

import Coder from "../../../../components/Coder.js";

function PhoneVerificationFragment({
  checkCurrentVerificationStatus = () => {},
  setErrorMsg = () => {},
  itemFocusRef = null,
  closeModalFunction = () => {},
}) {
  const dispatch = useDispatch();

  ///////////////////////////////////////////////////////////////reudx state
  const loginState = useSelector((state) => state.loginState);

  ////////////////////////////////////////////////////REFS
  //const refMiniInput1 = useRef(); zamjenjen s parent elementom


  ////////////////////////////////////////////////////LOCAL STATES

  const [verificationAttempted, setVerificationAttempted] = useState(false);
  const [coderCode, setCoderCode] = useState("");
  const [coderCodeFull, setCoderCodeFull] = useState("");

  ////////////////////////////////////////////////////VARIABLES DERIVATED FROM STATE

  ////////////////////////////////////////////////////EFFECTS
  useEffect(() => {
    //pita za obje verfikacije
    let resPromise;
    let resPromiseInterval;

    let canAskAgainPromise;
    let canAskAgainPromiseInterval;

    let intervalCounter = 0;
    canAskAgainPromise = canAskForSMSverificationTokenAgain(true);
    resPromise = checkCurrentVerificationStatus();
    const interval = setInterval(() => {
      intervalCounter++;
      if (intervalCounter > 60) {
        clearInterval(interval);
      }
      resPromiseInterval = checkCurrentVerificationStatus();
      canAskAgainPromiseInterval = canAskForSMSverificationTokenAgain(false);
    }, 3000);

    return () => {
      if (resPromise) {
        resPromise.abort();
      }

      if (resPromiseInterval) {
        resPromiseInterval.abort();
      }

      if (canAskAgainPromise) {
        canAskAgainPromise.abort();
      }

      if (canAskAgainPromiseInterval) {
        canAskAgainPromiseInterval.abort();
      }

      clearInterval(interval);
    };
  }, []);

  ////////////////////////////////////////////////////handleFunctions

  ////////////////////////////////////////////////////METHODS
  const canAskForSMSverificationTokenAgain = (showLoading) => {
    const resPromise = dispatch(
      loginAsyncActions.canAskForSMSverificationTokenAgain(showLoading)
    );
    return resPromise;
  };

  const sendSMSverificationTokenAgain = async () => {
    dispatch(
      loginAsyncActions.sendSMSverificationAgain({
        setErrorMsg: setErrorMsg,
      })
    );
  };

  const verifySMStoken = async (code, canVerify) => {
    if (canVerify === false) {
      return false;
    }

    dispatch(
      loginAsyncActions.verifySMStoken({
        token: code,
        setErrorMsg: setErrorMsg,
        closeModal: closeModalFunction,
        setVerificationAttempted: setVerificationAttempted,
      })
    );

    return false;
  };

  if (verificationAttempted) {
    return <></>;
  }

  ////////////////////////////////////////////////////RENDER
  return (
    <>
      {loginState.login.userInfo.canAskForSMSverificationTokenAgain && (
        <BaseButton onClick={sendSMSverificationTokenAgain}>
          sendConfirmationCode
        </BaseButton>
      )}

      <Coder
        stateSetter={setCoderCode}
        onEnter={(code, codeFull) => {
          verifySMStoken(code, codeFull);
        }}
        fullCodeStateSetter={setCoderCodeFull}
      />
      <BaseButton
        disabled={!coderCodeFull}
        onClick={() => verifySMStoken(coderCode, coderCodeFull)}
      >
        verify
      </BaseButton>
    </>
  );
}



export default PhoneVerificationFragment;
